import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export default function PublicLoginRoute({ children }) {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();

  if (auth.isAuthenticated) {
    const from = location?.state?.from;
    const role = String(auth?.user?.role || "").toUpperCase();
    const isOrganizerPanelRole = role === "ORGANIZER" || role === "SELLER";
    if (!isOrganizerPanelRole && typeof from === "string" && !/^\/(login|register|organizer)/.test(from)) {
      return <Navigate to={from} replace />;
    }
    if (isOrganizerPanelRole) return <Navigate to="/organizer" replace />;
    return <Navigate to="/event" replace />;
  }
  return children;
}

